export default {
  development: 'http://localhost:3080',
  production: 'https://esteveteijin.qmkey.com/backend',
};
